export default __webpack_public_path__ + "static/media/exclamation.2acc28ea.svg";